import { render } from "./LoadingSuggestion.vue?vue&type=template&id=b645bbfc"
import script from "./LoadingSuggestion.vue?vue&type=script&lang=js"
export * from "./LoadingSuggestion.vue?vue&type=script&lang=js"

import "./LoadingSuggestion.vue?vue&type=style&index=0&id=b645bbfc&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__